import React from 'react';
import { useLocation } from 'react-router-dom';
import { useAppSelector } from '../../store';
import LogoutButton from './LogoutButton';
import Section from './components/Section';
import Item from './components/Item';
import { FiHome, FiVideo, FiRadio, FiShield, FiPackage, FiFileText, FiRefreshCw, FiMapPin, FiClipboard, FiUsers } from 'react-icons/fi';
import { Accordion } from './components/Accordion';

export default function InchargeSidebar() {
    const location = useLocation();
    const pso = useAppSelector((s) => s.user.pso);
    const designation = pso?.designation || '';
    
    // Determine incharge type (remove underscores if present)
    const inchargeType = designation.replace(/_/g, ' ').toLowerCase();
    const isCCTV = inchargeType.includes('cctv');
    const isBAMS = inchargeType.includes('bams');
    const isGuarding = inchargeType.includes('guarding');
    const isMIS = inchargeType.includes('mis');

    return (
        <div className="flex h-screen flex-col bg-white text-gray-900 dark:bg-[#0f172a] dark:text-white">
            <div className="shrink-0 border-b border-gray-200 p-4 text-sm font-semibold dark:border-white/10">
                {designation || 'Incharge Menu'}
            </div>
            <nav className="flex-1 overflow-y-auto p-2 text-sm">
                <Accordion defaultOpenId="main">
                    <Section id="main" title="Main Menu" alwaysOpen>
                        <Item icon={FiHome} label="Dashboard" to="/dashboard" active={location.pathname === '/dashboard'} />
                    </Section>
                    
                    {(isCCTV || isBAMS || isMIS) && (
                        <Section id="hardware" title="Hardware Management" subtitle="Manage Hardware Installations">
                            {(isCCTV || isMIS) && (
                                <Item 
                                    icon={FiVideo} 
                                    label="CCTV Hardware" 
                                    to="/manage-hardware-cctv" 
                                    active={location.pathname === '/manage-hardware-cctv'} 
                                />
                            )}
                            {(isBAMS || isMIS) && (
                                <Item 
                                    icon={FiRadio} 
                                    label="BAMS Hardware" 
                                    to="/manage-hardware-bams" 
                                    active={location.pathname === '/manage-hardware-bams'} 
                                />
                            )}
                        </Section>
                    )}


                    {/* For Incharge_Guarding, hide Guarding Operations and Reports */}

                    {isMIS && (
                        <Section id="mis" title="MIS Management" subtitle="Manage MIS Operations">
                            <Item 
                                icon={FiClipboard} 
                                label="Branch Surveys" 
                                to="/surveys" 
                                active={location.pathname === '/surveys'} 
                            />
                            <Item 
                                icon={FiUsers} 
                                label="Manage Vendors" 
                                to="/companies" 
                                active={location.pathname === '/companies'} 
                            />
                            <Item 
                                icon={FiRefreshCw} 
                                label="Change of Vendor" 
                                to="/change-of-vendor" 
                                active={location.pathname === '/change-of-vendor'} 
                            />
                            <Item 
                                icon={FiMapPin} 
                                label="New Location Surveys" 
                                to="/new-location-surveys" 
                                active={location.pathname === '/new-location-surveys'} 
                            />
                        </Section>
                    )}

                    {isMIS && (
                        <Section id="requests" title="Requests" subtitle="Manage Request Forms">
                            <Item 
                                icon={FiFileText} 
                                label="Request Form" 
                                to="/request-form" 
                                active={location.pathname === '/request-form'} 
                            />
                            <Item 
                                icon={FiVideo} 
                                label="CCTV Hardware Request" 
                                to="/cctv" 
                                active={location.pathname === '/cctv'} 
                            />
                            <Item 
                                icon={FiRadio} 
                                label="BAMS Hardware Request" 
                                to="/bams" 
                                active={location.pathname === '/bams'} 
                            />
                        </Section>
                    )}

                    {/* View-only request access for non-MIS incharge */}
                    {(isCCTV || isBAMS || isGuarding) && (
                        <Section id="requests" title="Requests" subtitle="View Request Status">
                            <Item 
                                icon={FiFileText} 
                                label="View Requests" 
                                to="/request-form" 
                                active={location.pathname === '/request-form'} 
                            />
                            {isCCTV && (
                                <Item 
                                    icon={FiVideo} 
                                    label="CCTV Hardware Request" 
                                    to="/cctv" 
                                    active={location.pathname === '/cctv'} 
                                />
                            )}
                            {isBAMS && (
                                <Item 
                                    icon={FiRadio} 
                                    label="BAMS Hardware Request" 
                                    to="/bams" 
                                    active={location.pathname === '/bams'} 
                                />
                            )}
                            <Item 
                                icon={FiRefreshCw} 
                                label="Change of Vendor" 
                                to="/change-of-vendor" 
                                active={location.pathname === '/change-of-vendor'} 
                            />
                        </Section>
                    )}

                    {!isGuarding && !isMIS && (
                        <Section id="inventory" title="Inventory" subtitle="Track and Manage Items">
                            {isCCTV && (
                                <Item 
                                    icon={FiPackage} 
                                    label="CCTV Items" 
                                    to="/inventory?category=CCTV" 
                                    active={location.pathname === '/inventory' && new URLSearchParams(location.search).get('category') === 'CCTV'} 
                                />
                            )}
                            {isBAMS && (
                                <Item 
                                    icon={FiPackage} 
                                    label="BAMS Items" 
                                    to="/inventory?category=BAMS" 
                                    active={location.pathname === '/inventory' && new URLSearchParams(location.search).get('category') === 'BAMS'} 
                                />
                            )}
                        </Section>
                    )}
                </Accordion>
            </nav>
            <div className="shrink-0">
                <LogoutButton />
            </div>
        </div>
    );
}

